'use strict';

module.exports = '2.26.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 139
// module chunks = 35783957827783 114276838955818